
// eslint-disable-next-line
export const findBrandObjFromName = (name, brands) => (brands.find(b => (b.name === name)) || {});
